export function realmSecretNamesForDisplay(
  config: Record<string, unknown> | null,
  storedNames: string[],
): string[] {
  const names = new Set(storedNames);
  collectCredentialRefs(config, names);
  return Array.from(names).sort((a, b) => a.localeCompare(b));
}

function collectCredentialRefs(value: unknown, names: Set<string>): void {
  if (Array.isArray(value)) {
    value.forEach((item) => collectCredentialRefs(item, names));
    return;
  }
  if (value === null || typeof value !== "object") return;

  const record = value as Record<string, unknown>;
  const credentialRef = record.credential_ref;
  if (typeof credentialRef === "string" && credentialRef.length > 0) {
    names.add(credentialRef);
  }
  Object.values(record).forEach((item) => collectCredentialRefs(item, names));
}